import AppBar from "@material-ui/core/AppBar";
import IconButton from "@material-ui/core/IconButton";
import { withStyles } from "@material-ui/core/styles";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import MenuIcon from "@material-ui/icons/Menu";
import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import { languages } from "../../constants/languages";
import AccountMenuContainer from "../../containers/AccountMenuContainer";
import LanguageMenuContainer from "../../containers/LanguageMenuContainer";
import PresentationMenuContainer from "../../containers/PresentationMenuContainer";
import nvdLogo from "../../img/NVD-logo.svg";
import logo from "../../img/tournify-logo.svg";
import HelpMenuButton from "./HelpMenuButton";
// import { Button } from "@material-ui/core";

// const upgradeLogoNormal = require("../../img/trophy-icon.png");

const styles = (theme) => ({
  root: {
    width: "100%",
  },
  // appBar: {
  // zIndex: theme.zIndex.modal + 1
  // },
  appBar: {
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    width: `calc(100% - ${310}px)`,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginRight: 310,
  },
  flex: {
    flex: 1,
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20,
  },
  logo: {
    height: 20,
    marginRight: 5,
  },
  navIconHide: {
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
  backIconHide: {
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  nvd: {
    height: 64,
    marginLeft: 10,
    [theme.breakpoints.down("xs")]: {
      display: "none",
    },
  },
  subscribeButton: {
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  subscribeIconButton: {
    display: "none",
    [theme.breakpoints.down("sm")]: {
      display: "block",
    },
  },
});

const HeaderBar = (props) => {
  const { classes } = props;
  let stylePSD = {};
  let isPSDUser = false;
  if ((props.userData || {}).isPSD) {
    stylePSD["backgroundColor"] = "black";
    isPSDUser = true;
  }
  if (props.psd) {
    stylePSD["backgroundColor"] = "black";
  }

  // const hasSubscription = [1, 2, 3].includes((props.userStatus || {}).status);

  return (
    <div className={classes.root}>
      <AppBar
        position="fixed"
        style={stylePSD}
        className={classNames(classes.appBar, {
          [classes.appBarShift]: props.drawerOpen,
        })}
      >
        <Toolbar
          style={{
            paddingLeft:
              (props.isTournament || props.account || props.features) &&
              !isPSDUser
                ? 10
                : 24,
            paddingRight: (props.tournament || {}).nvdCode ? 0 : 10,
          }}
        >
          {props.isTournament && !props.new && !isPSDUser ? (
            <div>
              <IconButton
                color="inherit"
                aria-label="open drawer"
                onClick={props.handleDrawerToggle}
                className={classes.navIconHide}
                style={{ color: "white" }}
              >
                <MenuIcon />
              </IconButton>
              <IconButton
                color="inherit"
                onClick={props.handleBack}
                className={classes.backIconHide}
                style={{ color: "white" }}
              >
                <ArrowBackIcon />
              </IconButton>
            </div>
          ) : (props.account || props.features) && !isPSDUser ? (
            <IconButton
              color="inherit"
              onClick={props.handleBack}
              className={
                !props.account && !props.features ? classes.backIconHide : ""
              }
              style={{ color: "white" }}
            >
              <ArrowBackIcon />
            </IconButton>
          ) : !isPSDUser ? (
            <img src={logo} alt="" className={classes.logo} />
          ) : (
            ""
          )}
          <Typography
            variant="h6"
            color="inherit"
            className={classes.flex}
            style={{
              color: "white",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              overflow: "hidden",
            }}
          >
            {!isPSDUser && (
              <span>
                {props.isTournament
                  ? props.new
                    ? ""
                    : (props.tournament || {}).name || ""
                  : props.features
                  ? languages.features.tournifyDev
                  : ""}
              </span>
            )}
            {isPSDUser && (
              <span>
                <span style={{ color: "#FED906" }}>PSD</span> powered by
                Tournify
              </span>
            )}
          </Typography>
          {props.isTournament &&
            !props.new &&
            !(props.tournament || {}).nvdCode &&
            props.upgradeButton}
          {props.isTournament && !props.new && (
            <PresentationMenuContainer
              tournament={props.tournament}
              isPSDUser={isPSDUser}
            />
          )}
          {/* TODO: Activate when we make sure that on the checkout page it's clear that there's not ONLY a subscription option */}
          {/* {!props.isTournament && !hasSubscription && (
            <div>
              <Button
                className={classes.subscribeButton}
                color="inherit"
                style={{ color: "white" }}
                // TODO: Fix the handleClickUpgrade function, before enabling again
                onClick={props.handleClickUpgrade}
              >
                <img
                  style={{ height: 20, marginRight: 5 }}
                  src={upgradeLogoNormal}
                  alt=""
                />
                <span>{languages.upgrade.upgrade}</span>
              </Button>
              <IconButton
                className={classes.subscribeIconButton}
                color="inherit"
                style={{ color: "white" }}
                // TODO: Fix the handleClickUpgrade function, before enabling again
                onClick={props.handleClickUpgrade}
              >
                <img
                  style={{ height: 20, marginRight: 5 }}
                  src={upgradeLogoNormal}
                  alt=""
                />
              </IconButton>
            </div>
          )} */}
          {(!props.isTournament || props.new) && <LanguageMenuContainer />}
          {!props.drawerOpen && !props.features && !props.account && (
            <HelpMenuButton
              handleOpen={props.handleOpen}
              handleClose={props.handleOpen}
            />
          )}
          {props.user && !props.user.isAnonymous && (
            <AccountMenuContainer user={props.user} />
          )}
          {(props.tournament || {}).nvdCode && (
            <img className={classes.nvd} src={nvdLogo} alt="" />
          )}
        </Toolbar>
      </AppBar>
    </div>
  );
};

HeaderBar.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(HeaderBar);
